import React from 'react';
import { connect } from 'react-redux';
import _ from 'underscore';
import xtend from 'xtend';
import isWindows from 'is-windows';
import { render, h } from 'preact';
import struct from '@nichoth/observ/struct';
import Model from '@nichoth/observ/model';
import Editor from '@invintusmedia/editor';

import { getHasRequestPending } from '../redux/data/selectors'
import queryString from '../utils/QueryString';
import { Link } from 'react-router-dom'
import { hasPermission } from '../lib/components/form/RestrictedComponent';
import actions from '../redux/actions';
import Loader from '../common/components/notifications/Loader';
import { track, EVENTS } from '../lib/tracking';

function EditorRoute(api, ws, opts) {
    var queryParams = queryString.parse(window.location.search);
    var models = {
        event: EventModel({ io: api.events }),
        editJobs: EditJobs({ io: api.edit })
    }

    var state = struct({
        event: Model.getState(models.event),
        editJobs: Model.getState(models.editJobs),
        shownPermissionWarning: false
    })

    if (process.env.NODE_ENV === 'development') {
        window.state = state;
        window.EventModel = EventModel;
    }

    EditJobs.subscribeToWebsocket(state.editJobs, ws);
    EventModel.subscribeToWebsocket(models.event, ws);

    // this is a temporary integration with the external editor repo,
    // which is made with preact
    class EditorWrapper extends React.Component {
        constructor(props) {
            super(props)
            this.state = state()

            this.startedLoading = false
            this.loaded = false
            this._unsubscribe = null;
            this._preactNode = null;
            this._isWindows = null;
            this.submitEdit = this.submitEdit.bind(this);
        }

        // ev is the list of clips
        submitEdit(ev) {
            if (!hasPermission('event_videoEditor.commit')) {
                window.alert("you do not have permission to save edits")
                return
            }
            var event = this.props.event;

            // need to format the request with clips grouped by assetID
            var clips = ev.map(function (clip, i) {
                var cutout = clip.cutout || _(event.mediaAssets).findWhere({
                    assetID: clip.assetID
                }).totalRunTimeS

                return {
                    assetID: clip.assetID,
                    order: i,
                    cutin: clip.cutin || 0,
                    cutout
                }
            });

            var clipsByAsset = _(clips).groupBy('assetID')
            var assetItems = _(clipsByAsset).map(function (clips, assetID) {
                return {
                    assetID,
                    edits: clips.map(function (clip) {
                        var _clip = xtend(clip);
                        delete _clip.assetID;
                        return _clip;
                    })
                }
            });

            var req = {
                operation: 'edit',
                eventID: event.eventID,
                assetItems
            }

            models.editJobs.commit(req, function (err, res) {
                if (err) {
                    // @TODO show error to the user
                    return;
                }

                track(EVENTS.EDITOR_SAVE);
                // show a snack type thing
            })
        }

        componentDidMount() {
            track(EVENTS.EDITOR_OPEN, { has_event_id: Boolean(queryParams.eventID) });

            // need this for tooltip styles
            document.body.classList += ' inv-editor-route-body'




            if (!hasPermission("event_videoEditor.commit") && !this.state.shownPermissionWarning) {
                this.setState({ shownPermissionWarning: true })
                window.alert("You do not have permission to save edits!")
            }

            models.event.get({
                eventID: queryParams.eventID,
                showEncoder: true,
                showMediaAssets: true,
                showStreams: true,
                includePrivate: true,
                getLiveMetaData: true
            })

            this.props.requestEvent(queryParams.eventID)
            this.startedLoading = true

            // this._unsubscribe = state(function onChange(_state) {
            //     self.setState(_state);
            // });

        }

        componentDidUpdate(prevProps, prevState) {
            // @TODO handle error state from events.get call
            // if we render the preact editor without event data it will
            // crash. Should maybe patch that case in the editor repo

            var shouldRender = !this.props.pending && this.props.finishedRequestingLogItems && this.props.event
            if (!this.loaded && !this.props.pending && this.startedLoading && !!this.props.event && !this.requestingLogItems) {
                // request all of the log items for all of the event assets
                this.requestingLogItems = true
                this.props.requestEventLogItems(queryParams.eventID)
            }
            if (!this.loaded && !this.props.pending && this.props.event && this.props.finishedRequestingLogItems) {
                this.requestingLogItems = false
                this.loaded = true
            }
            var self = this;
            self._isWindows = isWindows();
            var el = document.getElementById('editor-wrapper');
            this._preactNode = document.getElementById('inv-editor')
            if (shouldRender) {
                var el = document.getElementById('editor-wrapper');
                const options = {
                    event: this.props.event,
                    eventMetaMarkers: this.props.eventMetaMarkers,
                    editJobs: this.state.editJobs,
                    onSubmit: this.submitEdit,
                    rootNode: el
                }
                if (!!el) {
                    render(h(Editor, options), el, this._preactNode)
                }
            }
        }

        componentWillUnmount() {
            // remove the added editor css when unmounting
            document.body.classList.remove('inv-editor-route-body')
            var el = document.getElementById('editor-wrapper');
            render(() => null, el, this._preactNode);
            this.loaded = false
            this.startedLoading = false
            // this._unsubscribe();
        }

        render() {
            var { state, props } = this;

            var altKey = this._isWindows ? 'alt' : 'opt';
            const { event, pending, finishedRequestingLogItems } = props;
            if (!this.loaded || pending || !finishedRequestingLogItems) {
              return (
                <div style={{ height: '100vh' }}>
                  <Loader />
                </div>
              )
            }

            let loggerLink = '/agenda?eventID=' + event.eventID
            
            return <div className="editor-route">
                <div className="editor-route-head">
                    {event.title ?
                        <>
                            <Link to={'/events/?eventID=' + event.eventID}>
                                {event.title}
                            </Link>,
                            <span className="event-id">
                                {' ' + event.eventID}
                            </span>
                            <div className="logger-link">
                                <Link to={loggerLink}>
                                    Agenda Logger
                                </Link>
                            </div>
                        </> :
                        null}
                </div>

                <div id="editor-wrapper" />

                <div className="inv-editor-info">

                    <div className="editor-shortcut-info">
                        <div className="shortcut-head">
                            <i className="fa fa-info-circle" aria-hidden={true} />
                            {' Keyboard shortcuts'}
                        </div>

                        <div>
                            <em>space</em> play/pause
                        </div>
                        <div>
                            <em>left/right arrow</em> step back or forward 1 second
                        </div>
                        <div>
                            <em>shift + left/right arrow</em> step back or forward 30 seconds
                        </div>

                        <div>
                            <em>{altKey} + left/right arrow</em> jump to previous or next clip start
                        </div>

                        <div>
                            <em>x</em> cut at the current time
                        </div>

                        <div>
                            <em>-</em> zoom out
                        </div>

                        <div>
                            <em>+</em> zoom in
                        </div>

                        <div>
                            <em>shift -</em> zoom out ×10
                        </div>

                        <div>
                            <em>shift +</em> zoom in ×10
                        </div>
                    </div>

                    <div className="inv-editor-legend">
                        <div className="editor-legend-head">
                            <i className="fa fa-info-circle" aria-hidden={true} />
                            {' Timeline markers'}
                        </div>

                        <div className="legend-agenda">
                            <i className="fa fa-caret-down" aria-hidden={true} />
                            <span> Agenda item</span>
                        </div>

                        <div className="break-marker-legend">
                            <i className="fa fa-caret-right" aria-hidden={true} />
                            <span> Break start</span>
                        </div>

                        <div className="break-marker-legend">
                            <i className="fa fa-caret-left" aria-hidden={true} />
                            <span> Break end</span>
                        </div>
                    </div>

                </div>


            </div>;
        }
    }

    return connect(mapStateToProps, mapDispatchToProps)(EditorWrapper);
}

const mapStateToProps = (state) => {
    const eventID = queryString.parse(window.location.search).eventID;
    const event = state.data.events[eventID]
    const pending = getHasRequestPending(state, ['DATA/GET_FULL_EVENT', 'DATA/GET_EVENT_LOG_ITEMS'])
    const finishedRequestingLogItems = !pending && !state.data.isRequestingEventLogItems

    const eventMetaMarkers = state.data.eventLogItems[eventID] || {}
    return {
        event,
        eventMetaMarkers,
        eventID,
        pending,
        finishedRequestingLogItems
    }
}
const mapDispatchToProps = (dispatch) => ({
    requestEvent: (eventID) => dispatch(actions.data.requestFullEvent(eventID)),
    requestEventLogItems: (eventID) => dispatch(actions.data.requestEventLogItems({eventID}))
})

export default EditorRoute


// this is new assets that we created through the editor
// (not other assets, for example from uploading a new file)
function EditJobs({ io }) {
    var editJobs = Model({
        io: {
            commit: io.commit
        },

        state: {
            // these are placeholder assets
            jobs: struct({})
        },

        update: {
            commit: function (state, res) {
                var newJobs = {};
                newJobs[res.data.placeholder_assetID] = res.data;
                state.jobs.set(xtend(state.jobs(), newJobs));
            }
        }
    });

    return editJobs;
}


// edit related ws messages
// these all have the assetID of the placeholder asset we get in the
// edit/commit response

// asset/add
// {"action":{"method":"asset","type":"add"},"errors":{"hasError":false,"message":null},"data":{"assetID":"d1a43f15025028283000ab7b712b050a7846f955","clientID":"1000000000","eventID":"2018091034","name":"Edit: 2018-10-08 17:19:10","type":"edit","dateCreated":"2018-10-08 17:19:10","fileSize":null,"totalRunTime":null,"totalRunTimeS":null,"currentStatus":"processing edit","fileUrl":"https:\/\/invintus-mediaworkflow.s3.amazonaws.com\/1000000000\/d1a43f15025028283000ab7b712b050a7846f955.mp4","thumbnail":"","sprite":null,"liveID":null,"recStartDate":null,"recStopDate":null,"estRecDur":null,"path":"https:\/\/invintus-mediaworkflow.s3.amazonaws.com\/1000000000\/d1a43f15025028283000ab7b712b050a7846f955.mp4","TTL":"2018-10-18 17:19:10","advancedDetails":false,"previewURI":"https:\/\/invintus-mediaworkflow.s3.amazonaws.com\/1000000000\/d1a43f15025028283000ab7b712b050a7846f955.mp4"},"meta":[]}

// transcode/processing
// {"action":{"method":"transcode","type":"processing"},"data":{"clientID":"1000000000","assetID":"d1a43f15025028283000ab7b712b050a7846f955","eventID":"2018091034","progress":50,"transcodeID":"188c6ed0-cb57-11e8-8a98-c7849043adfc"},"errors":{"hasError":false,"message":null}}

// transcode/start
// {"action":{"method":"transcode","type":"start"},"errors":{"hasError":false,"message":null},"data":{"assetID":"d1a43f15025028283000ab7b712b050a7846f955","clientID":"1000000000","eventID":"2018091034","name":"Edit: 2018-10-08 17:19:10","type":"edit","dateCreated":"2018-10-08 17:19:10","fileSize":null,"totalRunTime":null,"totalRunTimeS":null,"currentStatus":"editing","fileUrl":"https:\/\/invintus-mediaworkflow.s3.amazonaws.com\/1000000000\/d1a43f15025028283000ab7b712b050a7846f955.mp4","thumbnail":"","sprite":null,"liveID":null,"recStartDate":null,"recStopDate":null,"estRecDur":null,"path":"https:\/\/invintus-mediaworkflow.s3.amazonaws.com\/1000000000\/d1a43f15025028283000ab7b712b050a7846f955.mp4","TTL":"2018-10-18 17:19:10","advancedDetails":false,"previewURI":"https:\/\/invintus-mediaworkflow.s3.amazonaws.com\/1000000000\/d1a43f15025028283000ab7b712b050a7846f955.mp4"},"meta":[]}

// transcode/complete
// {"action":{"method":"transcode","type":"complete"},"errors":{"hasError":false,"message":null},"data":{"assetID":"d1a43f15025028283000ab7b712b050a7846f955","clientID":"1000000000","eventID":"2018091034","name":"Edit: 2018-10-08 17:19:10","type":"edit","dateCreated":"2018-10-08 17:19:10","fileSize":null,"totalRunTime":null,"totalRunTimeS":null,"currentStatus":"editing","fileUrl":"https:\/\/invintus-mediaworkflow.s3.amazonaws.com\/1000000000\/d1a43f15025028283000ab7b712b050a7846f955.mp4","thumbnail":"","sprite":null,"liveID":null,"recStartDate":null,"recStopDate":null,"estRecDur":null,"path":"https:\/\/invintus-mediaworkflow.s3.amazonaws.com\/1000000000\/d1a43f15025028283000ab7b712b050a7846f955.mp4","TTL":"2018-10-18 17:19:10","advancedDetails":false,"previewURI":"https:\/\/invintus-mediaworkflow.s3.amazonaws.com\/1000000000\/d1a43f15025028283000ab7b712b050a7846f955.mp4"},"meta":[]}

// thumbs/add
// {"action":{"method":"thumbs","type":"add"},"errors":{"hasError":false,"message":null},"data":[{"assetID":"d1a43f15025028283000ab7b712b050a7846f955","clientID":"1000000000","eventID":"2018091034","name":"Edit: 2018-10-08 17:19:10","type":"video","dateCreated":"2018-10-08 17:19:10","fileSize":"30093472","totalRunTime":"00:04:44","totalRunTimeS":284,"currentStatus":"available","fileUrl":"https:\/\/invintus-mediaworkflow.s3.amazonaws.com\/1000000000\/d1a43f15025028283000ab7b712b050a7846f955.mp4","thumbnail":"https:\/\/invintus-client-images.s3.amazonaws.com\/1000000000\/d1a43f15025028283000ab7b712b050a7846f955.jpg","sprite":null,"liveID":null,"recStartDate":null,"recStopDate":null,"estRecDur":null,"path":"https:\/\/invintus-mediaworkflow.s3.amazonaws.com\/1000000000\/d1a43f15025028283000ab7b712b050a7846f955.mp4","TTL":"2018-10-18 17:19:10","advancedDetails":{"general":{"filename":"d1a43f15025028283000ab7b712b050a7846f955.mp4","format":"mpeg-4","filesize":30093472,"durationHMS":"00:04:44","durationS":284,"bitrate":848},"video":[{"format":"avc","bitrate":668,"dimensions":{"width":"1280","height":"720"},"aspect_ratio":"16:9","framerate_mode":"Variable","frame_rate":"24.975 fps","stream_size":23714215}],"audio":[{"format":"aac","title":"AAC","format_profile":"LC","bitrate":175,"channels":"2.0ch","stream_size":6218378}],"image":null,"text":null},"previewURI":{"main":"\/\/invintus-otfp.global.ssl.fastly.net\/1000000000\/d1a43f15025028283000ab7b712b050a7846f955.m3u8","backup":"https:\/\/invintus-mediaworkflow.s3.amazonaws.com\/1000000000\/d1a43f15025028283000ab7b712b050a7846f955.mp4"}}],"meta":[]}

EditJobs.subscribeToWebsocket = function (state, ws) {
    ws.on('data', function (msg) {
        var jobs = state.jobs();
        var { method, type } = msg.action;
        var { assetID } = msg.data;

        if (!assetID) return;
        if (!jobs[assetID]) return;

        // it seems like there could be a race condition if you're doing
        // short files, where we get all the ws messages before getting
        // a response to the xhr commit call. But let's assume there are
        // no race conditions for now, and we always get the commit response
        // before any relevant ws messages
        if (method === 'transcode' && type === 'complete') {
            var _jobs = xtend(state.jobs());
            delete _jobs[assetID];
            state.jobs.set(_jobs);
        }
    });
}

function EventModel({ io }) {
    var eventModel = Model({
        io: {
            get: io.get
        },

        state: {
            data: struct({
                mediaAssets: []
            })
        },

        update: {
            get: function (state, res) {
                state.data.set(res.data[0])
                state.hasFetched.set(true)
            },

            // sync update
            set: function (state, data) {
                if (!state().hasFetched) return;
                state.data.set(xtend(state.data(), data));
            }
        }
    })

    return eventModel
}

EventModel.updateExistingAsset = function (state, update) {
    if (!state().hasFetched) return;
    var event = state.data();
    var i = _(event.mediaAssets).findIndex(function (a) {
        return a.assetID === update.assetID;
    })
    if (i === -1) return i;

    var newAssets = event.mediaAssets.slice();
    newAssets[i] = xtend(newAssets[i], update);
    state.data.set(xtend(event, {
        mediaAssets: newAssets
    }));

    return i;
}

EventModel.addOrUpdateAsset = function (state, asset) {
    if (!state().hasFetched) return;
    var i = EventModel.updateExistingAsset(state, asset);
    var didUpdate = (i !== -1)
    if (didUpdate) return;

    var newAssets = ([asset]).concat(state.data().mediaAssets);
    state.data.set(xtend(state.data(), {
        mediaAssets: newAssets
    }));
}

EventModel.subscribeToWebsocket = function (model, ws) {
    ws.on('data', function (msg) {
        var state = Model.getState(model);
        var { method, type } = msg.action;

        if (method === 'thumbs' && type === 'add') {
            // msg.data is an array
            var thumbUpdates = msg.data;
            var event = state.data();
            var { mediaAssets } = event;
            var didUpdate = false;
            var newAssets = mediaAssets.slice();
            thumbUpdates.forEach(function (asset) {
                if (asset.eventID !== event.eventID) return;
                var i = _(mediaAssets).findIndex(function (a) {
                    return a.assetID === asset.assetID;
                })
                if (i === -1) return;

                newAssets[i] = xtend(mediaAssets[i], {
                    thumbnail: asset.thumbnail
                })
                didUpdate = true;
            })

            if (!didUpdate) return;
            state.data.set(xtend(state.data(), {
                mediaAssets: newAssets
            }))
        }

        var { eventID } = msg.data;
        if (!eventID || (eventID !== (state.data() || {}).eventID)) return;

        if (method === 'asset' && type === 'add') {
            EventModel.addOrUpdateAsset(state, msg.data);
        }

        if (method === 'transcode' && type === 'start') {
            EventModel.updateExistingAsset(state, msg.data);
        }

        if (method === 'transcode' && type === 'processing') {
            // EventModel.updateExistingAsset(state, msg.data);
        }

        // assets are considered in processing state until we get the
        // thumbnail/add message
        if (method === 'transcode' && type === 'complete') {
            EventModel.updateExistingAsset(state, msg.data);
        }
    })
}
